import { useDispatch, useSelector } from "react-redux";
import { environment, getOnlineServices } from "../util/index";
import RequestService from "../util/request";
import { createSetConfirmationModalAction, createFailureAction, createSetViewAction, createUpdateSchoolAction, createValidationAction } from "state/reducer";
import { AppMode, IADPState, VerifySetUpCodePayload, VerifySetUpCodeResponse } from "../Types/AppStateTypes";
import { useIPCBridge } from "./useIPCBridge";
const logPrefix = "[ADPClient][SetupCodeValidationServiceHook]"
export function useCodeValidationService() {
  const dispatch = useDispatch()
  const state = useSelector((state:{rootState:IADPState})=>state.rootState)
  const {sendSetupCode} = useIPCBridge();
  const clearSchoolDetails = ()=>{
    console.log(logPrefix, "clearing school details...");
    dispatch(createUpdateSchoolAction(undefined));
    dispatch(createValidationAction(undefined));
  }
  const validateCode = (code: string,codeType: AppMode)=>{
    console.log(logPrefix,` validate ${code} code for ${state.sessionState.selectedAssessmentMode} mode`);
    dispatch(createValidationAction("Verifying"));//takes care of displaying spinner
    const payload: VerifySetUpCodePayload = {
      appAccessedFor: codeType,
      adpLaunchId: state.appState.appLaunchId as string,
      setupCode: codeType == "Assess" ? code : undefined,
      verificationCode: codeType == "Verify" ? code : undefined,
      requestDateTime: new Date().toISOString(),
      deviceId: state?.deviceState?.deviceId? state?.deviceState?.deviceId:"NotAvailable",
    };
    
    const onlineServiceConfig = getOnlineServices(state.appState.configuration);
    //TODO implement npn mode
    const domain = onlineServiceConfig?.apiSubDomain?.includes("api") 
    ? environment.resolveApiDomain(state.appState.configuration) : environment.resolveENAEPDomain();
    let url = `${domain}/${onlineServiceConfig?.verifySetUpCode}?appName=adp&appVersion=${state.appState.appVersion}`;
    const onResponse = async (response: VerifySetUpCodeResponse) => {
      console.log(logPrefix,`setup code validation response status:`,response.status);
      clearSchoolDetails()//remove spinner
      if (response.status === 200) {
          sendSetupCode(code);
         console.table(response.status);
         dispatch(createUpdateSchoolAction(response));
        //  if(codeType === "Verify"){
        dispatch(createSetViewAction("DeviceValidationView"));
        //  }
        //  else {
          // dispatch(createSetConfirmationModalAction(true));
        //  }
         //if(!(response.assessmentLocations && response.assessmentLocations.length>0 && state?.appState?.configuration?.enableLocation)){TODO readd when I add in locations
          // dispatch(createSetViewAction("DeviceValidationView"));
         //}
        }
      else if (response.errorCode){
        console.table(response.status);
        dispatch(createUpdateSchoolAction({...response,setupCode:code}));
       } 
        else {
          console.error(logPrefix,"Error validating setup code",response.status);
          dispatch(createFailureAction("NoServerConnectionDetected"));
        }
    
      }
    RequestService.postCode(payload, url, onResponse);
  }
 
  return {validateCode,clearSchoolDetails}
}
